document.addEventListener("DOMContentLoaded", function () {
    const searchInputs = document.querySelectorAll("[data-quick-search-input]"); 
    const fauxSearchButtons = document.querySelectorAll("[data-quick-search-faux-input]"); 

    if (!searchInputs.length || !fauxSearchButtons.length) return;

    const searchSuggestions = [
        "Search for Calvin Klein...",
        "Search for Maybelline...",
        "Search for Huda Beauty...",
        "Search for Dior Makeup...",
        "Search for Rimmel...",
        "Search for Bourjois...",
        "Search for Charlotte Tilbury...",
        "Search for Paco Rabanne...",
        "Search for L'Oreal Skincare...",
        "Search for Cerave...",
        "Search for Neutrogena...",
    ];

    let suggestionIndex = 0;
    let charIndex = 0;
    let isDeleting = false;
    let lastText = "";

    function updatePlaceholders(text) {
        if (text === lastText) return; // Prevent unnecessary DOM updates
        lastText = text;

        searchInputs.forEach(input => input.setAttribute("placeholder", text));
        fauxSearchButtons.forEach(button => {
            const textElement = button.querySelector("[data-quick-search-faux-text]");
            if (textElement) textElement.innerText = text.replace("|", ""); 
        });
    }

    function typeEffect() {
        const currentText = searchSuggestions[suggestionIndex];

        if (!isDeleting) {
            updatePlaceholders(currentText.substring(0, charIndex) + "|");
            charIndex++;
            if (charIndex > currentText.length) {
                isDeleting = true;
                setTimeout(typeEffect, 800); // Longer pause before deleting
                return;
            }
        } else {
            updatePlaceholders(currentText.substring(0, charIndex) + "|");
            charIndex--;
            if (charIndex === 0) {
                isDeleting = false;
                suggestionIndex = (suggestionIndex + 1) % searchSuggestions.length;
            }
        }

        requestAnimationFrame(() => setTimeout(typeEffect, isDeleting ? 40 : 75)); // Adjusted timing for smoothness
    }

    requestAnimationFrame(typeEffect); // Uses the browser's optimized frame rendering
});
